import templateUrl from './subjectsTable.html';
import controller from './subjectsTable.controller';
import './subjectsTable.scss';

const subjectsTableDirective = () => {
	return {
		scope: {
			row: '<',
			columns: '<',
			rowActions: '<',
			gridRowActions: '<'
		},
		require: {
			table: '^^tableWrap'
		},
		controller,
		controllerAs: '$ctrl',
		bindToController: true,
		restrict: 'E',
		templateUrl,
		link(/*scope, element, attr, ctr*/) {},
		replace: true
	};
};

export default subjectsTableDirective;
